import { mapState } from 'vuex';
import _ from 'lodash';
import * as storeGetters from '~/store/getters';
import Loading from '~/components/loading/Loading.vue';
import { setJWTToken } from '~/utils/auth';
import { LOGIN_TYPES } from '~/utils/constants';

export default {
  components: {
    loading: Loading,
  },
  data() {
    return {
      error: null,
      loading: false,
    };
  },
  computed: {
    ...mapState('router', {
      token: state => _.get(state, 'query.jwtToken', null),
    }),
  },
  methods: {
    getLoginUrl() {
      const path = this.$router.resolve({ name: 'login' }).href;
      const redirectUrl = `${window.location.origin}${path}?jwtToken={token}`;
      const navigateTo = `${storeGetters.apiUrl()}v1/auth/remote/login?redirectUrl=${encodeURIComponent(redirectUrl)}`;

      window.location.href = navigateTo;
    },
  },
  mounted() {
    if (this.token) {
      this.loading = true;

      setJWTToken(this.token)
        .then(() => {
          this.loading = false;
          this.$emit('login-success', LOGIN_TYPES.SSO);
        })
        .catch(err => {
          this.loading = false;
          this.error = err;
        });
    }
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/login/sso/Sso.js